import { render, staticRenderFns } from "./channelPopup.vue?vue&type=template&id=6ce14c86&scoped=true"
import script from "./channelPopup.vue?vue&type=script&lang=js"
export * from "./channelPopup.vue?vue&type=script&lang=js"
import style0 from "./channelPopup.vue?vue&type=style&index=0&id=6ce14c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce14c86",
  null
  
)

export default component.exports